import { default as customer } from './customer/routes'

export default [
    ...customer
]
